/**
 * Put a document down (RFC 0297 §4f).
 *
 * NOT A DELETE, and that is the whole of the design. The entry appends beside
 * the looks rather than removing them, so the fold drops the holding until the
 * next look on that document brings it back, still knowing when it first came
 * into hand. Deleting the looks would lose the one fact the fold exists to keep.
 *
 * ON THE LOG, like every other decision about a session, so the tab that
 * dropped it, the phone watching, and the turn about to be assembled all read
 * the same answer. A local "hidden" flag in the renderer would be the lie RFC
 * 0297 exists to remove: a holding gone from the person's bar and still resident
 * in the agent's context.
 *
 * The agent may drop as well as the person. An agent that has finished with a
 * document knows that before anybody else does.
 */

import type { AnyDocumentId, Repo } from '@automerge/automerge-repo/slim'
import { BranchLog } from '../../log/branch-log'
import type { EntryId } from '../../log/types'

export async function putDownDocument(
  repo: Repo,
  sessionId: string,
  documentId: string,
): Promise<EntryId> {
  const handle = await repo.find(sessionId as AnyDocumentId)
  await (handle as { whenReady?: () => Promise<void> }).whenReady?.()
  return new BranchLog(handle as never).appendPutDown({ documentId })
}
